// API types and interfaces

export enum ApiErrorCode {
  UNKNOWN = 'UNKNOWN',
  NETWORK_ERROR = 'NETWORK_ERROR',
  TIMEOUT = 'TIMEOUT',

  // Auth errors
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_ALREADY_EXISTS_ERROR = 'USER_ALREADY_EXISTS_ERROR',
  USERNAME_ALREADY_EXISTS = 'USERNAME_ALREADY_EXISTS',
  EMAIL_ALREADY_EXISTS_ERROR = 'EMAIL_ALREADY_EXISTS_ERROR',
  PASSWORD_INVALID = 'PASSWORD_INVALID',
  EMAIL_INVALID = 'EMAIL_INVALID',
  PHONE_INVALID = 'PHONE_INVALID',
  CODE_INVALID = 'CODE_INVALID',
  CODE_NOT_VERIFIED = 'CODE_NOT_VERIFIED',
  CODE_EXPIRED = 'CODE_EXPIRED',
  PHONE_NUMBER_ALREADY_EXISTS_ERROR = 'PHONE_NUMBER_ALREADY_EXISTS_ERROR',
  REFERRAL_CODE_NOT_FOUND = 'REFERRAL_CODE_NOT_FOUND',

  // Permission errors
  ACTION_IS_NOT_ALLOWED = 'ACTION_IS_NOT_ALLOWED',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  MFA_NOT_VERIFIED = 'MFA_NOT_VERIFIED',

  // Validation errors
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  REQUIRED_FIELD_MISSING = 'REQUIRED_FIELD_MISSING',
  USER_NOT_VERIFIED = 'USER_NOT_VERIFIED',
  PHONE_NUMBER_NOT_SET = 'PHONE_NUMBER_NOT_SET',
  EMAIL_NOT_CONFIRMED = 'EMAIL_NOT_CONFIRMED',

  // Wallet errors
  INVALID_CRYPTO_ADDRESS_ERROR = 'INVALID_CRYPTO_ADDRESS_ERROR',
  CRYPTO_ADDRESS_ALREADY_EXISTS_ERROR = 'CRYPTO_ADDRESS_ALREADY_EXISTS_ERROR',

  // Transaction errors
  COUNTRY_RESTRICTED = 'COUNTRY_RESTRICTED',
  INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE',
}

export interface ErrorDetail {
  message: string
  code?: ApiErrorCode
  details?: any
}

export interface ApiResponse<T = any> {
  data: T
  success: boolean
  message?: string
}

export interface IOptionsUseMutation<T = any, V = any> {
  onSuccess?: (data: T, variables?: V) => void
  onError?: (
    error: ErrorDetail & { errorMessage?: string; code?: ApiErrorCode },
  ) => void
}
